var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "password-reset" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row mt-2 mb-2 mt-lg-5 mb-lg-5" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 mt-2 mt-lg-5" }, [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-12 col-lg-5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-row align-items-center justify-content-center d-flex"
                  },
                  [
                    _c("div", { staticClass: "input-group mb-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.passwordReset.email,
                            expression: "passwordReset.email"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.$v.passwordReset.email.$error
                        },
                        attrs: {
                          id: "inlineFormInputGroup",
                          placeholder: "Email",
                          type: "email"
                        },
                        domProps: { value: _vm.passwordReset.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.passwordReset,
                              "email",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-12 col-lg-5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-row align-items-center justify-content-center justify-content-lg-end d-flex my-2 mt-lg-3"
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-invalid": _vm.$v.passwordReset.email.$error
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-success btn-lg rounded-pill font-weight-bolder text-uppercase px-4",
                            attrs: { type: "submit" },
                            on: {
                              click: function($event) {
                                return _vm.action()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                    CONTINUAR\n                                "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "form-row align-items-center justify-content-center d-flex my-3"
              },
              [
                _c("validation-invalid-feedback", {
                  attrs: { params: _vm.$v.passwordReset.email.$params }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("modal-send-information", {
        attrs: {
          msgSuccess: {
            subtitle: "O email com o link para mudança de senha foi enviado"
          },
          "show-modal": _vm.displayProcessingInformation,
          success: _vm.responseSuccess,
          prefix: "follow-us"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 kit-center text-center mt-lg-3" }, [
      _c(
        "h2",
        {
          staticClass: "title-works kit-center line",
          staticStyle: {
            "background-image": "url(@asset('images/testimonials-line.png'))",
            "max-width": "600px"
          }
        },
        [_vm._v("\n                    Recuperação de senha\n                ")]
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "text-center ml-auto mr-auto mt-2",
          staticStyle: { "font-size": "20px", "max-width": "380px" }
        },
        [
          _vm._v(
            "Preencha o campo abaixo com o endereço de e-mail que está cadastrado na sua conta A Taba"
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib?{}!./scripts/vue/components/common/PasswordReset.vue?vue&type=template&id=9f2727b6&
// module id = 421
// module chunks = 1